import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";

import ICInput from "./form/input";

const ICTagInput = props => {
  const [tags, setTags] = useState([]);
  const [tagInputVal, setTagInputVal] = useState("");

  const handleInputChange = e => {
    setTagInputVal(e.target.value);
  };

  const handleOnInputKeyUp = e => {
    if (
      e.key === "Enter" &&
      tagInputVal !== undefined &&
      tagInputVal.trim() !== "" &&
      tagInputVal.trim().length > 2
    ) {
      let newList = tags;
      newList.push(tagInputVal.trim());
      setTagInputVal("");
      setTags(newList);
      saveTags();
    }
  };

  const handleOnInputKeyDown = e => {
    if (
      (e.key === "Backspace" || e.key === "Delete") &&
      tagInputVal !== undefined &&
      tagInputVal.trim().length === 0 &&
      tags.length > 0
    ) {
      let newList = tags;
      newList = newList.filter((val, i) => {
        return i !== tags.length - 1;
      });
      setTags(newList);
      saveTags();
    }
  };

  const removeSelTag = index => {
    let newList = tags;
    newList = newList.filter((val, i) => {
      return i !== index;
    });
    setTags(newList);
    saveTags();
  };

  const saveTags = () => {
    let tg = tags;

    let res = "";

    for (let i = 0; i < tg.length; i++) {
      res = res + tg[i];

      if (tg.length !== 1 && tg.length - 1 !== i) {
        res = res + ",";
      }
    }

    props.setTagsValue(res);
  };

  return (
    <Fragment>
      <div
        className={
          tags.length > 0
            ? "tag-input-container d-flex flex-column"
            : "tag-input-container d-flex flex-row"
        }
      >
        <div className="d-flex flex-row flex-wrap">
          <i className="fas fa-tag primary-color tag-icon"></i>

          {tags.length > 0
            ? tags.map((tag, index) => (
                <div className="tag" key={index}>
                  {tag}&nbsp;
                  <i
                    className="fas fa-times ml-1"
                    onClick={e => {
                      removeSelTag(index);
                    }}
                  ></i>
                </div>
              ))
            : ""}
        </div>
        <ICInput
          name="title"
          placeholder="Add tags for seach optimisation: ie. telehealth"
          value={tagInputVal}
          onChange={handleInputChange}
          onKeyUp={handleOnInputKeyUp}
          onKeyDown={handleOnInputKeyDown}
        />
      </div>
      <span style={{ marginTop: "5px", fontSize: "12px" }}>
        {tagInputVal !== undefined && tagInputVal.trim().length > 0
          ? "Press Enter to Add Tag"
          : ""}
      </span>
    </Fragment>
  );
};

export default ICTagInput;

ICTagInput.defaultProps = {
  setTagsValue: () => {}
};

ICTagInput.propTypes = {
  setTagsValue: PropTypes.func
};
